/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

module.exports = function(requestData) {
  return $.soap({
    body: {
      SubmitAdminCreateEnforcementActionTask: {
        $xmlns: 'http://dobs.pa.gov/nd/task/bpm/1.0',
        TaskID: requestData.taskId,
        ComplianceID: requestData.complianceId,
        IsConsentToEA: requestData.isConsentToEa,
        FinalizedOrderDocumentID: requestData.finalizedOrderDocumentId,
        DocketNumber: requestData.docketNumber,
        OrderTypeID: requestData.orderTypeId,
        NegotiatedDate: requestData.negotiatedDate,
        SentToEntityDate: requestData.sentToEntityDate,
        SentToLegalDate: requestData.sentToLegalDate,
        FullyExecutedDate: requestData.fullyExecutedDate
      }
    }
  });
};
